import React from 'react';

import classNames from 'classnames';
import PersonIcon from 'icons/person-lg.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const componentSizeClassNames = new Map([
  [
    'xs',
    new Map([
      ['parentClassNames', 'tw-w-6 tw-h-6'],
      ['textClassNames', 'tw-text-xs'],
    ]),
  ],
  [
    'sm',
    new Map([
      ['parentClassNames', 'tw-w-8 tw-h-8'],
      ['textClassNames', 'tw-text-sm'],
    ]),
  ],
  [
    'md',
    new Map([
      ['parentClassNames', 'tw-w-16 tw-h-16'],
      ['textClassNames', 'tw-text-2xl'],
    ]),
  ],
  [
    'lg',
    new Map([
      ['parentClassNames', 'tw-w-20 tw-h-20'],
      ['textClassNames', 'tw-text-3xl'],
    ]),
  ],
]);

export default function ProfilePhotoDisplay({
  componentSize,
  photoUrl,
  profileInitials,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (() => {
    if (photoUrl) {
      return (
        <img
          alt={i18nTShared('profile')}
          className={classNames(
            'tw-rounded-full',
            componentSizeClassNames.get(componentSize).get('parentClassNames'),
          )}
          src={photoUrl}
        />
      );
    }

    if (profileInitials.length === 2) {
      return (
        <div
          className={classNames(
            'tw-flex tw-flex-none tw-items-center tw-justify-center tw-rounded-full tw-bg-blue-050',
            componentSizeClassNames.get(componentSize).get('parentClassNames'),
          )}
        >
          <span
            className={classNames(
              'tw-flex tw-items-center tw-justify-center tw-align-middle tw-font-semibold tw-uppercase tw-text-grey-600',
              componentSizeClassNames.get(componentSize).get('textClassNames'),
            )}
          >
            {profileInitials}
          </span>
        </div>
      );
    }

    return (
      <div
        className={classNames(
          'tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-grey-200',
          componentSizeClassNames.get(componentSize).get('parentClassNames'),
        )}
      >
        <PersonIcon className='[&_path]:tw-fill-white' height={40} width={40} />
      </div>
    );
  })();
}

ProfilePhotoDisplay.propTypes = {
  componentSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']).isRequired,
  photoUrl: PropTypes.string,
  profileInitials: PropTypes.string,
};
